module.exports = __webpack_public_path__ + "static/media/vl5.ef2bc133.jpeg";